import React from "react";
import { useDetail } from "seed/gql";
import { usePost } from "seed/api";
import View from "components/collections/forms/PermissionForm.view";

function PermissionForm({ 
  flowId, 
  collectionId, 
  initialValues,
  refetchCollections,
  onParentSubmit,
  closeModal = () => {}
}) {

  const qCollection = useDetail(`{
		collection {
			id
			schema
			name
			type
			settings
      uiSettings
		}
	}`, collectionId);

  const [callSetSettings] = usePost("/collections/update_collection", {
    onCompleted: (data) => {
      refetchCollections();
      closeModal();
    }
  });

  const onSubmit = (values) => {
    
    if(onParentSubmit) {
      onParentSubmit(values);
      return;
    }

    callSetSettings({
      collection_id: collectionId,
      settings: values
    });

  }
    

  const { collection = {} } = qCollection.data || {};
  const collectionSettings = collection.settings || {};

  return <View
    flowId={flowId}
    collectionId={collectionId}
    collectionSettings={initialValues || collectionSettings}
    onSubmit={onSubmit}
  />;

}

export default PermissionForm;